export default __webpack_public_path__ + "static/media/gsn_logo_desktop.51cd42de.png";